export const MIN_DURATION = 30;
export const MAX_DURATION = 480;
